export default __webpack_public_path__ + "static/media/colors-1440w.68c1ec40.avif";